import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MessageModule, ModalModule} from 'ng-design-system';
import {I18nModule} from '@spartacus/core';
import {
  AdditionalInformationMessageComponent
} from './additional-information-message/additional-information-message.component';


@NgModule({
  declarations: [
    AdditionalInformationMessageComponent,
  ],
  imports: [
    CommonModule,
    ModalModule,
    I18nModule,
    MessageModule
  ],
  exports: [
    AdditionalInformationMessageComponent,
  ]
})
export class AdditionalInformationModule {
}
